export default __webpack_public_path__ + "static/media/JaenPierreChoulet.89a08eeb.svg";